module.exports = __webpack_public_path__ + "img/question.513bb9ff.svg";